export default [
  { key: 'handler_abbr', label: 'Handler Abbrivation', _style: 'width:25%' },
  { key: 'name', label: 'Name', _style: 'width:40%' },
  { key: 'pro_handler', label: 'Pro Handler', sorter: false, _style: 'width:15%' },
  { key: 'amateur_handler', label: 'Amateur Handler', sorter: false, _style: 'width:15%' },
  { key: 'status', label: 'Status', sorter: false, _style: 'width:15%' },
  { key: 'user', label: 'Owner', sorter: false },
  { key: 'action', label: '', _style: 'width:10%' }
]
